import React, { useContext, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { SidebarContext } from './SidebarContext';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import PieChartDashboard from './PieChartDashboard';
import BarChart from './BarChart';
import { SparklesIcon, Squares2X2Icon } from '@heroicons/react/24/outline';

const Dashboard = () => {
  const navigate = useNavigate();
  const { isSidebarOpen } = useContext(SidebarContext);

  useEffect(() => {
    const userId = localStorage.getItem('id');
    const userName = localStorage.getItem('user_name');
    const role = localStorage.getItem('role');
    if (!userId || !userName || !role) navigate('/');
  }, [navigate]);

  const userId = localStorage.getItem('id');
  const userName = localStorage.getItem('user_name');
  const role = localStorage.getItem('role');
  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';

  return (
    <div className="app-shell min-h-screen">
      <Navbar />
      <div className="flex pt-16">
        <Sidebar />
        <motion.main
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.25 }}
          className={`min-w-0 flex-1 transition-all duration-300 ${isSidebarOpen ? 'md:ml-72' : 'ml-0'}`}
        >
          <div className="mx-auto w-full max-w-screen-2xl px-3 py-4 sm:px-5 sm:py-5 lg:px-6 lg:py-6">
            <motion.div
              initial={{ opacity: 0, y: -8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35 }}
              className="page-surface mb-6 flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between sm:p-5"
            >
              <div className="min-w-0">
                <div className="mb-1 flex items-center gap-2">
                  <Squares2X2Icon className="h-4 w-4 text-brand-600" />
                  <span className="text-[11px] font-extrabold uppercase tracking-widest text-brand-600">Dashboard</span>
                </div>
                <h1 className="text-xl font-black leading-tight text-slate-950 sm:text-2xl">
                  {greeting}, <span className="text-brand-700">{userName}</span>
                </h1>
                <p className="mt-1 flex items-center gap-1 text-sm text-slate-500">
                  <SparklesIcon className="h-3.5 w-3.5" />
                  Your financial overview is ready
                </p>
              </div>

              <div
                className={`shrink-0 rounded-xl px-3 py-2 text-[11px] font-extrabold uppercase tracking-wider ${
                  role === 'company_owner'
                    ? 'bg-amber-100 text-amber-800'
                    : role === 'admin'
                      ? 'bg-brand-100 text-brand-700'
                      : 'bg-slate-100 text-slate-700'
                }`}
              >
                {role === 'company_owner' ? 'Owner' : role === 'admin' ? 'Admin' : 'Worker'}
              </div>
            </motion.div>

            <div className="space-y-5">
              <PieChartDashboard user_id={userId} user_name={userName} role={role} />
              <BarChart />
            </div>
          </div>
        </motion.main>
      </div>
    </div>
  );
};

export default Dashboard;
